import Pusher from 'pusher-js';
const { REACT_APP_PUSHER_APP_KEY = '', REACT_APP_PUSHER_APP_CLUSTER } = process.env;

export const channelsClient = new Pusher(REACT_APP_PUSHER_APP_KEY, {
  cluster: REACT_APP_PUSHER_APP_CLUSTER,
});
